module.exports = __webpack_public_path__ + "media/armano_and_the_clot.f62d7f61.mp4";